import { inject, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { filter, switchMap } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';

import {
  NewVersionConfirmationDialog,
} from '../../shared/components/new-version-confirmation-dialog/new-version-confirmation-dialog';

@Injectable({
  providedIn: 'root'
})
export class PromptUpdateService {
  private swUpdate = inject(SwUpdate);
  private ngbModal = inject(NgbModal);
  private http = inject(HttpClient);

  constructor() {
    this.swUpdate.unrecoverable.pipe(
      take(1),
    ).subscribe(() => {
      if ('caches' in window) {
        caches.keys().then(names => names.forEach(n => caches.delete(n)));
      }
      location.replace(location.origin);
    });


    this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
      switchMap(() => this.http.get<{ version: string }>('/version.json')),
      take(1),
    ).subscribe({
      next: ({version}) => {
        this.ngbModal.open(NewVersionConfirmationDialog, {
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          windowClass: 'custom-modal'
        }).componentInstance.args = {
          version,
          confirm: () => {
            location.replace(location.origin);
          }
        }
      },
      error: (err) => console.error('Version check failed:', err)
    });
  }
}
